import clsx from "clsx";
import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

interface PageErrorStateProps {
  icon: LucideIcon;
  /** Headline message shown in red. */
  message: ReactNode;
  /** Optional secondary detail line shown under the message. */
  details?: ReactNode;
  /** Label for the optional action button (e.g. "Back to sessions"). */
  retryLabel?: ReactNode;
  onRetry?: () => void;
  /**
   * Extra classes for the card container; replaces the default
   * vertical breathing room ("py-12").
   */
  className?: string;
}

/**
 * Centered error card for top-level page failures: icon, headline
 * message, optional detail line, and an optional action button.
 */
export default function PageErrorState({
  icon: Icon,
  message,
  details,
  retryLabel,
  onRetry,
  className,
}: PageErrorStateProps) {
  return (
    <div className={clsx("text-center", className ?? "py-12")}>
      <Icon className="h-12 w-12 text-red-400 mx-auto mb-4" />
      <p className="text-lg text-red-600 mb-2">{message}</p>
      {details ? <p className="text-secondary-500">{details}</p> : null}
      {retryLabel ? (
        <button onClick={onRetry} className="mt-4 btn-primary px-4 py-2">
          {retryLabel}
        </button>
      ) : null}
    </div>
  );
}
